import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { CommonService } from './common.service';

import { User } from '@models/user';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';


@Injectable()
export class UserService {


    constructor(private httpClient: HttpClient, private commonService: CommonService) { }


    public getSelf(): Observable<User> {

        return this.httpClient.get(environment.API_END_POINT + '/users/self', { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =><User>((<any>response).content),),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    public forgotPassword(username: string, email: string): Observable<boolean> {

        let body = {
            'username': username,
            'email': email
        }

        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        return this.httpClient.post(`${environment.API_END_POINT}/users/self/passwordReset`,
            body.toString(), { headers: headers })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    public resetPassword(user: User, password: string): Observable<boolean> {

        const params = new HttpParams({
            fromObject: {
                newPassword: password,
            }
        });

        return this.httpClient.post(`${environment.API_END_POINT}/users/${user.userId}/passwordReset`, params, { headers: this.commonService.getFormHeaders() })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    public modifyPassword(originalPassword: string, password: string): Observable<boolean> {

        const params = new HttpParams({
            fromObject: {
                originalPassword: originalPassword,
                newPassword: password,
            }
        });

        return this.httpClient.post(`${environment.API_END_POINT}/users/self/passwordModification`, params, { headers: this.commonService.getFormHeaders() })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    public modifyBaseInfo(fromObjectParam: any): Observable<boolean> {

        const params = new HttpParams({
            fromObject: fromObjectParam
        });

        return this.httpClient.post(`${environment.API_END_POINT}/users/self/baseInfoModification`, params, { headers: this.commonService.getFormHeaders() })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    public switchDomain(domainId: any, companyShortName: any): Observable<boolean> {

        const params = new HttpParams({
            fromObject: {
                workingDomain:domainId,
                companyShortName: companyShortName
            }
        });

        return this.httpClient.post(`${environment.API_END_POINT}/users/self/switchDomain`, params, { headers: this.commonService.getFormHeaders() })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    

    public resetPasswordByGenerate(userId: string): Observable<boolean> {


        return this.httpClient.post(`${environment.API_END_POINT}/users/${userId}/passwordResetByGenerate`, null, { headers: this.commonService.getHeaders() })
            .pipe(
                map(() => true),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

}

